// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2-5Oh","consentsList":"PatientConsents_consentsList__2F3yQ","consentsListEmpty":"PatientConsents_consentsListEmpty__2T3uv"};